// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1782ff","secondary":"#0073ae","accent":"#82b1ff","error":"#ff5252","info":"#2196f3","success":"#4caf50","warning":"#ffc107","neutral":"#f2f5f8","anchor":"#1782ff"};